import { Component } from '@verndale/core';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

class ProductGallery extends Component {
  setupDefaults() {
    this.dom = {
      inner: this.el.querySelector('.product-detail__gallery-inner'),
    };

    this.init();
    this.buildGalleryLightBox();
  }

  addListeners() {
    this.dom.galleryItems.forEach((item) => {
      item.addEventListener('click', this.displayGalleryLightBox.bind(this));
    });
  }

  init() {
    this.imagesCount = this.dom.inner.querySelectorAll('img').length;

    this.dom.inner.querySelectorAll('img').forEach((image, index) => {
      const button = document.createElement('button');
      button.classList.add('product-detail__gallery-item');
      button.dataset.index = index;
      button.appendChild(image);
      this.dom.inner.appendChild(button);
    });

    this.dom.galleryItems = this.dom.inner.querySelectorAll(
      '.product-detail__gallery-item'
    );

    if (this.imagesCount > 6) {
      const overlay = document.createElement('div');
      overlay.classList.add('product-detail__gallery-item-overlay');
      const label = this.el.dataset.viewMoreLabel;

      overlay.innerHTML = `<span>${label.replace(
        '[count]',
        this.imagesCount - 6
      )}</span>`;
      const lastImage = this.dom.galleryItems[5];
      lastImage.appendChild(overlay);
      this.dom.inner.dataset.imagesCount = 6;
    } else {
      this.dom.inner.dataset.imagesCount = this.imagesCount;
    }

    this.dom.inner.dataset.initialized = 'initialized';
  }

  buildGalleryLightBox() {
    this.dom.lightbox = document.createElement('dialog');
    // this.dom.lightbox.setAttribute('open', '');
    this.dom.lightbox.classList.add('product-detail__gallery-lightbox');
    this.dom.lightbox.innerHTML = `
      <div class="product-detail__gallery-lightbox-inner">
        <button class="product-detail__gallery-lightbox-close" autofocus>
          <svg role="presentation">
            <use xlink:href="#modal-close" />
          </svg>
        </button>
        <div class="product-detail__gallery-lightbox-content">
          ${
  this.imagesCount > 0
    ? `<div role="button" class="product-detail__gallery-lightbox-prev">
            <svg role="presentation">
              <use xlink:href="#modal-chevron-left" />
            </svg>
          </div>`
    : ''
}
          <div class="swiper-container">
            <div class="swiper-wrapper"></div>
          </div>
          ${
  this.imagesCount > 0
    ? `<div role="button" class="product-detail__gallery-lightbox-next">
            <svg role="presentation">
              <use xlink:href="#modal-chevron-right" />
            </svg>
          </div>`
    : ''
}
          ${
  this.imagesCount > 0
    ? '<div class="product-detail__gallery-lightbox-pagination"></div>'
    : ''
}
        </div>
      </div>
    `;

    document.body.appendChild(this.dom.lightbox);
    const sliderContainer = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-content .swiper-container'
    );
    const swiperWrapper = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-content .swiper-wrapper'
    );

    this.dom.lightboxClose = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-close'
    );
    this.dom.lightboxInner = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-inner'
    );
    this.dom.lightboxPagination = this.dom.lightbox.querySelector(
      '.product-detail__gallery-lightbox-pagination'
    );

    this.dom.inner.querySelectorAll('img').forEach((image) => {
      const swiperSlide = document.createElement('div');
      swiperSlide.classList.add('swiper-slide');
      swiperSlide.appendChild(image.cloneNode(true));
      swiperWrapper.appendChild(swiperSlide);
    });

    this.swiper = new Swiper(sliderContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: this.dom.lightboxInner.querySelector(
          '.product-detail__gallery-lightbox-next'
        ),
        prevEl: this.dom.lightboxInner.querySelector(
          '.product-detail__gallery-lightbox-prev'
        ),
      },
      on: {
        update: (swiper) => {
          this.dom.lightboxPagination.innerHTML = `${swiper.activeIndex + 1}/${
            swiper.slides.length
          }`;
        },
        slideChange: (swiper) => {
          this.dom.lightboxPagination.innerHTML = `${swiper.activeIndex + 1}/${
            swiper.slides.length
          }`;
        },
      },
    });
    this.dom.lightboxClose.addEventListener(
      'click',
      this.closeGalleryLightBox.bind(this)
    );
    this.dom.lightbox.addEventListener(
      'click',
      this.handleClickOutside.bind(this)
    );
  }

  displayGalleryLightBox(event) {
    const target = event.currentTarget;
    const index = target.dataset.index;

    this.swiper.slideTo(index);
    this.dom.lightbox.show();
    this.swiper.update();
  }

  closeGalleryLightBox() {
    console.log('entra');
    this.dom.lightbox.close();
  }

  handleClickOutside(event) {
    if (
      event.target === this.dom.lightbox &&
      !this.dom.lightboxInner.contains(event.target)
    ) {
      this.closeGalleryLightBox();
    }
  }
}

export default ProductGallery;
